var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "elementType": "li",
      "customClass": [{
        'hide': !_vm.isRandomizeEnabled || _vm.isApparel
      }, {
        'disabled': _vm.$store.state.utils.isRandomizeApplied
      }]
    }
  }, [_c('button', {
    staticClass: "tab-name tab-randomize__name",
    attrs: {
      "role": "button",
      "id": "randomize"
    },
    on: {
      "click": function click($event) {
        return _vm.onRandomizeClick();
      }
    }
  }, [_c('CustomContainer', {
    attrs: {
      "elementType": "div",
      "customClass": "tab-randomize__name__dynamic-background"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "elementType": "div",
      "customClass": "background-content"
    }
  })], 1), _c('CustomText', {
    attrs: {
      "customClass": "tab-randomize__name__value",
      "elementType": "span",
      "text": _vm.translations.tabRandomize
    }
  }), _c('CustomImage', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-randomize.svg"),
      "customClass": "tab-randomize__name__icon"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }